import type { Reducer } from 'redux';
import { produce } from 'immer';
import { defaultState, Fields } from '../data/FilterBarState';
import FilterBarConstants from '../models/FilterBarConstants';
import type { FilterBarActions } from './filter-bar-actions.types';

const reducer: Reducer<Fields, FilterBarActions> = (state = defaultState, action) => {
  return produce<Fields>(state, (draft) => {
    switch (action.type) {
      case FilterBarConstants.SET_SELECTED_FILTER:
        draft.selectedFilter = action.filterType;
        return draft;

      case FilterBarConstants.TOGGLE_SEARCH_BAR:
        draft.isSearchBarOpen = action.isSearchBarOpen;
        return draft;

      case FilterBarConstants.TOGGLE_FILTERS_BAR:
        draft.filterBarOpen = action.isFiltersBarOpen;
        return draft;

      default:
        return state;
    }
  });
};

export default reducer;
